import React, { Component } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import './style.css';

export default class MobileMenu extends Component {

    state = {
        isMenuShow: false,
    };


    menuHandler = () => {
        this.setState(prevState => ({
            isMenuShow: !prevState.isMenuShow
        }));
    };

    handleLinkClick = () => {
        // Call the prop function to hide the menu
        this.setState({ isMenuShow: false });
        this.props.onLinkClick(); // Call the function passed from Header
    };

    render() {
        const { isMenuShow } = this.state;

        return (
            <div>
                <div className={`mobileMenu ${isMenuShow ? 'show' : ''}`}>
                    <div className="close" onClick={this.menuHandler}><i className='fa fa-close'></i></div>
                  
                    <div className="logo2">
                        <h2>
                            <AnchorLink href='https://welcome2ourmoment-batch-one.vercel.app/'>The Olives' Wedding</AnchorLink>
                        </h2>
                    </div>
                    <ul className="responsivemenu">
                        <li><AnchorLink href='#couple' onClick={this.handleLinkClick}>Couple</AnchorLink></li>
                        <li><AnchorLink href='#story' onClick={this.handleLinkClick}>Story</AnchorLink></li>
                        {/* <li><AnchorLink href='#people' onClick={this.handleLinkClick}>People</AnchorLink></li> */}
                        <li><AnchorLink href='#event' onClick={this.handleLinkClick}>Events</AnchorLink></li>
                        {/* <li><AnchorLink href='#gallery' onClick={this.handleLinkClick}>Gallery</AnchorLink></li> */}
                        {/* <li><AnchorLink href='#rsvp' onClick={this.handleLinkClick}>Rsvp</AnchorLink></li> */}
                        <li><AnchorLink href='#wesuggest' onClick={this.handleLinkClick}>We Suggest</AnchorLink></li>
                        <li><AnchorLink href='#qna' onClick={this.handleLinkClick}>Q & A</AnchorLink></li>
                        {/* <li><AnchorLink href='#contact' onClick={this.handleLinkClick}>Contact</AnchorLink></li> */}
                    </ul>
                    <div className="logoOfMobMenu">
                         <img src='/images/tanda-letters.png' alt='w'/>
                    </div>
                </div>

                <div className="showmenu" onClick={this.menuHandler}><i className="fa fa-bars" aria-hidden="true"></i></div>         
            </div>
        );
    }
}